import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "./video_with_alternative_image.css";

const context = require.context('./', true, /_controller\.js$/);
application.load(definitionsFromContext(context));
